import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { MonHttpClientService } from '@monsido/http/http-client.service';

@NgModule({
    imports: [HttpClientModule],
    declarations: [],
    exports: [],
    providers: [MonHttpClientService],
})
export class MonHttpClientModule {}
